module.exports = __webpack_public_path__ + "static/img/mmym.5369be8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mmym.jpg
// module id = 3VNX
// module chunks = 4